import React, { useState } from "react";

import "./../styling/Calculator.css"

const MidpointCalculator = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [midpoint, setMidpoint] = useState(null);

  const calculateMidpoint = () => {
    const [lat1, lon1] = point1.split(/[, ]+/).map(Number);
    const [lat2, lon2] = point2.split(/[, ]+/).map(Number);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      alert("Invalid coordinates!");
      return;
    }

    const midLat = (lat1 + lat2) / 2;
    const midLon = (lon1 + lon2) / 2;

    setMidpoint(`${midLat.toFixed(6)}, ${midLon.toFixed(6)}`);
  };

  return (
    <div className="calculator-card">
      <h2>Midpoint Calculator</h2>
      <input type="text" placeholder="Enter Point 1 (lat, long)" value={point1} onChange={(e) => setPoint1(e.target.value)} />
      <input type="text" placeholder="Enter Point 2 (lat, long)" value={point2} onChange={(e) => setPoint2(e.target.value)} />
      <button onClick={calculateMidpoint}>Calculate Midpoint</button>
      {midpoint && <p>Midpoint: {midpoint}</p>}
    </div>
  );
};

export default MidpointCalculator;